import React from 'react';
import styled from 'styled-components';

const SIZE = '0.625rem';

const Base = styled.div`
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
  border-width: ${props => props.size || SIZE};
`;

export const LeftCaret = styled(Base)`
  border-left: none;
  border-right-color: inherit;
`;

export const RightCaret = styled(Base)`
  border-right: none;
  border-left-color: inherit;
`;

export const DownCaret = styled(Base)`
  border-bottom: none;
  border-top-color: inherit;
`;

export const UpCaret = styled(Base)`
  border-top: none;
  border-bottom-color: inherit;
`;

const COMPONENTS = {
  down: DownCaret,
  left: LeftCaret,
  right: RightCaret,
  up: UpCaret
};

export default class Caret extends React.Component {
  render() {
    const { direction, ...props } = this.props;
    const Component = COMPONENTS[direction] || DownCaret;

    return <Component {...props} />;
  }
}
